import clsx from "clsx";
import { useState, useEffect } from "react";
import { copyToClipboard } from "@helpers";

export default function Coordinates(props) {
    const { lat, lon } = props.coordinates;
    const coordinatesString = `Lat ${lat}, Long ${lon}`;
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (copied) {
            setInterval(() => {
                setCopied(false);
            }, 10000);
        }
    }, [copied]);

    return (
        <div
            onClick={() => copyToClipboard(coordinatesString, setCopied)}
            className={clsx(
                wrapperStyle,
                copied ? " bg-green text-black" : " bg-darkGray text-white/70",
            )}
        >
            {copied ? (
                "Copied!"
            ) : (
                <>
                    <div>Lat {lat}</div>
                    <div>Long {lon}</div>
                </>
            )}
        </div>
    );
}

const wrapperStyle = clsx(
    "z-10 -mb-10 flex w-[150px] cursor-pointer justify-around rounded-full px-2 py-1 text-xxs",
);
